import { render, staticRenderFns } from "./PlayPagination.vue?vue&type=template&id=ebc7d860&scoped=true"
import script from "./PlayPagination.vue?vue&type=script&lang=js"
export * from "./PlayPagination.vue?vue&type=script&lang=js"
import style0 from "./PlayPagination.vue?vue&type=style&index=0&id=ebc7d860&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebc7d860",
  null
  
)

export default component.exports